module.exports = "/_next/static/images/home-main-category-shopping-281450d54904fd05898042c26fd901e7.jpg";